import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MemberQuery } from '@fgb/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[inPopulation]',
})
export class InPopulationDirective {
  memberPopulation: string | undefined;
  private populations: string[] = [];
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private memberQuery: MemberQuery) {}

  @Input() set inPopulation(populations: string[]) {
    this.populations = populations;
  }

  ngOnInit() {
    this.viewContainer.clear();
    this.memberPopulation = this.memberQuery.getPopulationName();

    if (this.memberPopulation && this.populations.includes(this.memberPopulation)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
